// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3aqqs","footer":"ModalError_footer__3yTYT"};